import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input, Select } from "../../../../../_metronic/_partials/controls";
import { isActive, isAlive } from "../BenefisUIHelpers";
import { findDistrict } from "../../../MasterData/_redux/province/provinceCrud";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { getBenefisCategoryAll } from "../../../BenefisCategory/_redux/benefisCategory/benefisCategoryCrud";
import { BlockOrg } from "../../../../RoleChecker";

// Validation schema
const BenefisEditSchema = Yup.object().shape({
  name: Yup.string().required("Name organisasi wajib diisi"),
  pic: Yup.string().required("Nama penanggung jawab wajib diisi"),
  pic_hp: Yup.string().required("Hp wajib diisi"),
  pic_email: Yup.string().required("Email wajib diisi"),
  qty: Yup.string().required("Jumlah anggota wajib diisi"),
});

export function BenefisOrganizationEditForm({
  saveBenefis,
  actionsLoading,
  benefis,
  id,
}) {
  const [district, setDistrict] = useState([]);
  const [postalCode, setPostalCode] = useState([]);
  const [kotaValue, setKotaValue] = useState("");
  const [options, setoptions] = useState({
    benefis_category: [],
  });

  useEffect(() => {
    if (id) {
      setKotaValue(`${benefis.district}, ${benefis.city}, ${benefis.province}`);
      setPostalCode([benefis.postal_code]);
    }
  }, [benefis]);

  useEffect(() => {
    getBenefisCategoryAll()
      .then((res) =>
        setoptions((prevState) => ({
          benefis_category: res.data.data,
        }))
      )
      .catch((err) => console.log(err));
  }, []);

  const onSelectTag = (value, setFieldValue) => {
    const array = value.split(",");
    if (array.length === 3) {
      let index = district.findIndex(
        (i) =>
          i.district === array[0].trim() &&
          i.city === array[1].trim() &&
          i.province_name === array[2].trim()
      );

      setPostalCode(district[index].postalcode);

      setFieldValue("province", district[index].province_name);
      setFieldValue("city", district[index].city);
      setFieldValue("district", district[index].district);
      setKotaValue(
        `${district[index].district}, ${district[index].city}, ${district[index].province_name}`
      );
    }
  };

  const onInputChange = (e) => {
    const value = e.target.value;

    if (value.length >= 3) {
      let query = {
        district: value,
        city: value,
      };
      findDistrict(query).then((response) => {
        setDistrict(response.data.data);
      });
    }
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={benefis}
        validationSchema={BenefisEditSchema}
        onSubmit={(values) => {
          saveBenefis({ ...values, type: "ORGANISASI" });
        }}
      >
        {({
          handleSubmit,
          handleChange,
          setFieldValue,
          values,
          isSubmitting,
        }) => (
          <>
            <Form className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-3">
                  <Field
                    name="name"
                    component={Input}
                    placeholder="Name Organisasi"
                    label="Nama Organisasi"
                  />
                </div>
                <div className="col-lg-3">
                  <Field
                    name="pic"
                    component={Input}
                    placeholder="Nama penanggung jawab"
                    label="Penanggung Jawab"
                  />
                </div>
                <div className="col-lg-3">
                  <Field
                    name="pic_hp"
                    component={Input}
                    placeholder="Untuk Indonesia 08xx"
                    label="No. Hp"
                  />
                </div>
                <div className="col-lg-3">
                  <Field
                    name="pic_email"
                    component={Input}
                    placeholder="Email"
                    label="Email"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-3">
                  <label>Kategori Benefis</label>
                  <Autocomplete
                    name="benefis_category_uuid"
                    options={options.benefis_category}
                    value={
                      options.benefis_category.length > 0 &&
                      options.benefis_category.find(
                        (item) => item.uuid === values.benefis_category_uuid
                      )
                    }
                    getOptionLabel={(option) => option.name}
                    onChange={(e, value) => {
                      value
                        ? setFieldValue("benefis_category_uuid", value.uuid)
                        : setFieldValue("benefis_category_uuid", null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Pilih Kategori Benefis"
                        variant="outlined"
                        disableClearable
                        size="small"
                      />
                    )}
                  />
                </div>
                <div className="col-lg-4">
                  <Field
                    name="qty"
                    component={Input}
                    placeholder="Masukkan jumlah anggota"
                    label="Jumlah anggota"
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-lg-8">
                  <Autocomplete
                    id="searchPostalCode"
                    disableClearable
                    onChange={(e, value) => {
                      onSelectTag(value, setFieldValue);
                    }}
                    value={kotaValue}
                    options={district.map(
                      (option) =>
                        `${option.district}, ${option.city}, ${option.province_name}`
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Cari Kota / Kecamatan"
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          type: "search",
                        }}
                        onChange={(e) => {
                          onInputChange(e);
                        }}
                      />
                    )}
                  />
                </div>
                <div className="col-lg-4">
                  <Select name="postal_code" label="Kodepos">
                    <option value="">-PILIH-</option>
                    {postalCode.map((row) => (
                      <option key={row} value={row}>
                        {row}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>

              <div className="form-group row" style={{ display: "none" }}>
                <div className="col-lg-3">
                  <Field
                    name="province"
                    component={Input}
                    placeholder="Provinsi"
                    label="Provinsi"
                    disabled={true}
                  />
                </div>
                <div className="col-lg-4">
                  <Field
                    name="city"
                    component={Input}
                    placeholder="Kota"
                    label="Kota"
                    disabled={true}
                  />
                </div>
                <div className="col-lg-3">
                  <Field
                    name="district"
                    component={Input}
                    placeholder="Kecamatan"
                    label="Kecamatan"
                    disabled={true}
                  />
                </div>
              </div>
              {/* <div className="form-group">
                <Field
                  name="address"
                  component={Input}
                  placeholder="Address"
                  label="Address"
                />
              </div> */}

              <div className="form-group row">
                <div className="col-lg-4">
                  <Field
                    name="nik"
                    component={Input}
                    placeholder="NIK / Nomor KTP / Nomor Perusahaan"
                    label="NIK / Nomor KTP / Nomor Perusahaan"
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-lg-4">
                  <Select name="is_alive" label="Status Hidup">
                    {isAlive.map((row) => (
                      <option key={row.value} value={row.value}>
                        {row.name}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="col-lg-4">
                  <Select name="is_active" label="Status Aktif">
                    {isActive.map((row) => (
                      <option key={row.value} value={row.value}>
                        {row.name}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
              {BlockOrg() && (
                <button
                  type="submit"
                  className="float-right btn btn-primary"
                  // style={{ display: "none" }}
                  // ref={btnRef}
                  onSubmit={() => handleSubmit()}
                  // disabled={isSubmitting}
                >
                  Simpan
                </button>
              )}
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
